<template>
    <el-dialog
            :title="$t('support_order')"
            visible
            width="50%"
            class="support-dialog-cls"
            @close="onCancel"
    >
        <div class="item">
            <div class="item-label">{{ $t('problem_description')}}<span style="color: #fd349c">*</span></div>
            <div class="item-content">
                <el-input type="textarea" :rows="4" v-model="problem"/>
            </div>
        </div>
        <div class="item">
            <div class="item-label">
                {{ $t('order_file')}}
            </div>
            <div class="item-content">
                <el-upload
                        ref="upload"
                        multiple
                        action
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :file-list="fileList"
                        :before-upload="beforeUpload"
                        :http-request="requestUpload">
                    <el-button size="small" type="primary">{{$t('click_to_upload')}}</el-button>
                </el-upload>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitContact">{{ $t('btn_submit')}}</el-button>
      </span>
    </el-dialog>
</template>

<script>
  import API from '@/api'

  export default {
    name: "ContactUs",
    data() {
      return {
        problem: '',
        fileList: []
      }
    },
    props: {
      account: {
        type: String,
        default: ''
      },
      onCancel: {
        type: Function,
        default: () => {
        }
      },
    },
    methods: {
      requestUpload(item) {
        this.fileList.push(item.file);
      },
      handleRemove(file, fileList) {
      },
      handlePreview(file) {
      },
      beforeUpload(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 5MB!');
        }
        return isLt5M;
      },
      submitContact() {
        let des = this.problem.trim()
        if (des == '' || des == null) {
          this.$message.error(this.$t('problem_description_null'))
          return
        }
        let fileParams = new FormData()
        fileParams.append('feedback', des)
        this.fileList.forEach(it => {
          fileParams.append('files', it)
        });
        fileParams.append('email', this.account)
        this.upload(fileParams)
      },
      async upload(fileParams) {
        try {
          const {data, code} = await API.common.contactUs(fileParams)
          if (code == '1') {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: this.$t('file_upload_success2', {email: this.account}),
              type: 'success'
            });
            this.onCancel()
          } else {
            this.$message.error(this.$t(code))
          }
        } catch (e) {
          this.$message.error(this.$t('file_upload_failed'))
        }
      }
    }
  }
</script>

<style scoped>
    .support-dialog-cls ::v-deep .el-dialog .el-dialog__title{
        font-size: 18PX;
    }
    .support-dialog-cls ::v-deep .el-dialog .el-button--small{
        font-size: 12PX;
    }
    .support-dialog-cls .item{
        display: flex;
        justify-content: flex-start;
        margin-bottom: 10px;
    }
    .support-dialog-cls .item .item-label{
        width: 140px;
        font-size: 12PX;
    }
    .support-dialog-cls .item .item-content{
        width: calc(100% - 160px);
        font-size: 12PX;
    }
    ::v-deep .logo-uploader .el-upload--text{
        width: 380px;
        font-size: 12PX;
    }
</style>